import React, { createContext, useEffect, useReducer } from 'react';

// third-party
import { Chance } from 'chance';
import jwtDecode from 'jwt-decode';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// project imports
import Loader from 'ui-component/Loader';
// import axios from 'utils/axios';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// types
import { KeyedObject } from 'types';
import { InitialLoginContextProps, JWTContextType } from 'types/auth';

const chance = new Chance();

// constant
const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

const verifyToken: (st: string) => boolean = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded: KeyedObject = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
     */
    return decoded.exp > Date.now() / 1000;
};

const setSession = (serviceToken?: string | null, user?: string | null) => {
    if (serviceToken && user) {
        localStorage.setItem('serviceToken', serviceToken);
        localStorage.setItem('xentai_user', user);
    } else {
        localStorage.removeItem('serviceToken');
        delete axios.defaults.headers.common.Authorization;
    }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //
const JWTContext = createContext<JWTContextType | null>(null);

export const JWTProvider = ({ children }: { children: React.ReactElement }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);
    const navigate = useNavigate();
    useEffect(() => {
        const init = () => {
            try {
                const serviceToken = window.localStorage.getItem('serviceToken');
                const user = JSON.parse(window.localStorage.getItem('xentai_user') || '[]');

                // console.log('Service Token', serviceToken);
                // console.log('User', user);
                if (serviceToken && user) {
                    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;

                    dispatch({
                        type: LOGIN,
                        payload: {
                            isLoggedIn: true,
                            user
                        }
                    });
                    navigate('/dashboard/default');
                } else {
                    console.log('Logout called');
                    dispatch({
                        type: LOGOUT
                    });
                }

                // if (serviceToken && verifyToken(serviceToken)) {
                //     setSession(serviceToken);
                //     const response = await axios.get('/profile/me');
                //     console.log('User data is', response.data);
                //     const { user } = response.data;
                //     dispatch({
                //         type: LOGIN,
                //         payload: {
                //             isLoggedIn: true,
                //             user
                //         }
                //     });
                // } else {
                //     dispatch({
                //         type: LOGOUT
                //     });
                // }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: LOGOUT
                });
            }
        };

        init();
    }, []);

    const login = async (email: string, password: string) => {
        // console.log('Login function has been called');
        const loginInfos = {
            deviceId: 'POST_MAN_ID',
            deviceType: 'POSTMAN',
            pushToken: 'PUSHTOKEN'
        };
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/auth/login`, { email, password, ...loginInfos });
        // console.log('Response is', response.data);
        const { accessToken, user, refreshToken } = response.data.data;
        setSession(accessToken, JSON.stringify(user));
        dispatch({
            type: LOGIN,
            payload: {
                isLoggedIn: true,
                user
            }
        });
        navigate(user?.role === 2 ? '/reddit' : '/dashboard/default');
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    };

    const register = async (email: string, password: string, firstName: string, lastName: string) => {
        // todo: this flow need to be recode as it not verified
        const id = chance.bb_pin();
        const response = await axios.post('/api/account/register', {
            id,
            email,
            password,
            firstName,
            lastName
        });
        let users = response.data;

        if (window.localStorage.getItem('users') !== undefined && window.localStorage.getItem('users') !== null) {
            const localUsers = window.localStorage.getItem('users');
            users = [
                ...JSON.parse(localUsers!),
                {
                    id,
                    email,
                    password,
                    name: `${firstName} ${lastName}`
                }
            ];
        }

        window.localStorage.setItem('users', JSON.stringify(users));
    };

    const logout = () => {
        setSession(null, null);
        dispatch({ type: LOGOUT });
    };

    const resetPassword = (email: string) => console.log(email);

    const updateProfile = () => {};

    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    return (
        <JWTContext.Provider value={{ ...state, login, logout, register, resetPassword, updateProfile }}>{children}</JWTContext.Provider>
    );
};

export default JWTContext;
